export { default } from './Event';



// WEBPACK FOOTER //
// ./src/js/views/event/index.js